<div class="pointer-events-auto h-full w-full" *ngIf="isLoaded">
    <div class="flex flex-col-1 h-full w-full dispatch-filter-panel"
    [ngClass]="{
        'filter-footer-available': filterOptions?.footer?.enabled !== false && !hideSaveFilter, 'filter-footer-available-without-save': filterOptions?.footer?.enabled !== false && hideSaveFilter}">

        <div class=" h-full w-full bg-white">
            <!-- Filter Header -->
            <div class="p-4 border-b dispatch-filter-header-container">
                <div class="flex items-start justify-between">
                    <div class="flex items-center">
                        <h2 class="text-xl font-semibold primary-font">
                            {{'calendar.home.popup.title' | translate}}</h2>
                    </div>
                    <div class="ml-auto flex h-7 items-center" *ngIf="filterOptions?.showCloseIcon !== false">
                        <div class="flex flex-shrink-0 ml-auto cursor-pointer rounded-full w-10 h-10 hover:bg-gray-200 items-center justify-center -mr-1"
                            (click)="closeFilterPanel()">
                            <em class="ti ti-x text-xl"></em>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Filter Body -->
            <div class="job-calendar-filter-body-container overflow-y-auto overflow-x-hidden zuper-scrollbar px-5">
                <!-- Filter - GRID -->
                <div class="py-4">
                    <form class="primary-font" autocomplete="off" [formGroup]="jobFilterForm">

                        <!-- Job Search -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.search_job' | translate}}
                            </label>
                            <input type="text" formControlName="jobSearch" name="job_search" id="job_search"
                                class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                                placeholder="{{'text.search_job' | translate}}">
                        </div>
                        <!-- Job Category -->
                        <div class="mb-4" *ngIf="jobsCategory">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'job.category' | translate}}
                            </label>
                            <ng-select class="job-category-filter" [items]="jobsCategory" bindLabel="category_name"
                                bindValue="category_uid" [multiple]="true" [searchable]="true" appendTo="body"
                                placeholder="{{'text.select_category' | translate}}"
                                (change)="changeJobCategory($event)" groupBy="selectedAllCategories"
                                [selectableGroup]="true" formControlName="jobCategory" [hideSelected]="false"
                                [closeOnSelect]="false">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-2"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        {{'text.select_all_categories' | translate}}
                                    </div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-2"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        {{item.category_name}}
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <ng-container
                                        *ngIf="items.length > 0 && !(items.length === 1 && items[0]?.selectedAllCategories && !items[0]?.category_uid)">
                                        <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                            [ngClass]="{'hidden' : items.length > 2}">
                                            <span class="ng-value-label text-base">{{item.category_name}}</span>
                                            <span class="ng-value-icon right text-base" (click)="clear(item)"
                                                aria-hidden="true">×</span>
                                        </div>
                                    </ng-container>
                                    <div class="ng-value"
                                        *ngIf="items.length === 1 && items[0]?.selectedAllCategories && !items[0]?.category_uid">
                                        <span class="primary-font ng-value-label text-base">
                                            {{jobsCategory.length}} {{'categories.selected.text' | translate}}
                                        </span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'categories.selected.text' | translate}}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Job Status -->
                        <div class="mb-4" *ngIf="jobFilterForm.get('jobCategory')?.value?.length">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.job_status' | translate}}
                            </label>
                            <ng-select class="job-status-filter" [items]="jobsStatuses" bindLabel="status_name"
                                bindValue="status_uid" [multiple]="true" [searchable]="true" appendTo="body"
                                placeholder="{{'text.select_status' | translate}}" groupBy="category_name"
                                (change)="changeJobStatus($event)" formControlName="jobStatus" [hideSelected]="false"
                                [closeOnSelect]="isAnyStatus">
                                <ng-template ng-header-tmp let-item="item">
                                    <div class="primary-font text-base flex pl-5 items-center">
                                        <input id="any_job_status" type="checkbox" class="mr-2 cursor-pointer"
                                            (change)="setAnyJobStatus($event)" [checked]="isAnyStatus" />
                                        <label for="any_job_status" class="cursor-pointer">{{'text.select_all' | translate}}</label>
                                    </div>
                                </ng-template>
                                <ng-template ng-optgroup-tmp let-item="item">
                                    <div class="primary-font text-lg font-bold">
                                        {{item?.category_name}}
                                    </div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-2"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        {{item.status_name}}
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <ng-container
                                        *ngIf="items.length > 0 && !(items.length === 1 && items[0]?.selectedAllStatuses && !items[0]?.status_uid)">
                                        <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                            [ngClass]="{'hidden' : items.length > 2}">
                                            <span class="ng-value-label text-base">{{item.status_name}}</span>
                                            <span class="ng-value-icon right text-base" (click)="clear(item)"
                                                aria-hidden="true">×</span>
                                        </div>
                                    </ng-container>
                                    <div class="ng-value"
                                        *ngIf="items.length === 1 && items[0]?.selectedAllStatuses && !items[0]?.status_uid">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'statuses.selected.text' | translate}}
                                        </span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'statuses.selected.text' | translate}}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                         <!-- assigned status -->
                         <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.calendar.filter.assigned.status' | translate}}
                            </label>
                            <ng-select class="job-priority-filter" [items]="assignedStatus" bindLabel="assignedType"
                                bindValue="assignedKey" [clearable]="false" [searchable]="false" [hideSelected]="false"
                                appendTo="body" placeholder="{{'text.select_status' | translate}}"
                                formControlName="assigned">
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="primary-font text-base flex items-center">
                                        {{item.assignedType}}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Due Date Type -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'due.date.text' | translate}}
                            </label>
                            <ng-select class="job-due-date-filter" [items]="dateTypes" bindLabel="dateType"
                                bindValue="dateKey" [clearable]="false" [searchable]="false" [hideSelected]="false"
                                appendTo="body" placeholder="{{'due.date.text' | translate}}"
                                (change)="changeDueDateType($event)" formControlName="dueDateType">
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="primary-font text-base flex items-center">
                                        {{item.dateType}}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Due Date - Date Range -->
                        <div class="mb-4 grid grid-cols-2 gap-4"
                            *ngIf="jobFilterForm.get('dueDateType')?.value === 'CUSTOM'">
                            <div class="w-full">
                                <label class="block text-base mb-2 font-medium text-gray-600">
                                    {{'text.due_from_date' | translate}}
                                </label>
                                <input [matDatepicker]="due_from_date" type="text" name="due_from_date"
                                    id="due_from_date"
                                    class="w-full mt-0.5 mr-4 block rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                                    placeholder="{{'text.due_from_date' | translate}}" (click)="due_from_date.open()"
                                    [datePickerFormat]="dateFormat" formControlName="dueDateFrom">
                                <mat-datepicker #due_from_date></mat-datepicker>
                            </div>
                            <div class="w-full">
                                <label class="block text-base mb-2 font-medium text-gray-600">
                                    {{'text.due_to_date' | translate}}
                                </label>
                                <input [matDatepicker]="due_to_date" type="text" name="due_to_date" id="due_to_date"
                                    class="w-full mt-0.5 mr-4 block rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                                    placeholder="{{'text.due_to_date' | translate}}" (click)="due_to_date.open()"
                                    [datePickerFormat]="dateFormat" formControlName="dueDateTo">
                                <mat-datepicker #due_to_date></mat-datepicker>
                            </div>
                        </div>
                        <!-- Customer -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'reports.home.customer.reports_title' | translate}}
                            </label>
                            <ng-select class="job-select-filter-field" [items]="customers | async" [multiple]="true"
                                formControlName="customer" appendTo="body" bindLabel="customer_first_name"
                                bindValue="customer_uid" [loading]="customerFetching" [closeOnSelect]="false"
                                [typeahead]="customerValueSubject" (clear)="onCustomerClear()"
                                (search)="onCustomerSearch()" (scrollToEnd)="onCustomerScrollToEnd()"
                                placeholder="{{'text.select_customer' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        <div class="primary-font text-base flex flex-col">
                                            <p class="font-medium">
                                                {{item.customer_first_name}} {{item.customer_last_name ?? ''}}
                                            </p>
                                            <p *ngIf="item.customer_email">
                                                {{item.customer_email}}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.customer_first_name}}
                                            {{item.customer_last_name ?? ''}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'customers.selected.text' | translate}}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Organization -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.organization' | translate}}
                            </label>
                            <ng-select class="job-select-filter-field" [items]="organizations | async" [multiple]="true"
                                formControlName="organization" appendTo="body" bindLabel="organization_name"
                                bindValue="organization_uid" [loading]="organizationFetching" [closeOnSelect]="false"
                                [typeahead]="organizationValueSubject" (clear)="onOrganizationClear()"
                                (search)="onOrganizationSearch()" (scrollToEnd)="onOrganizationScrollToEnd()"
                                placeholder="{{'text.select_organization' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        <div class="primary-font text-base flex flex-col">
                                            <p class="font-medium">
                                                {{item.organization_name}}
                                            </p>
                                            <p *ngIf="item.organization_email">
                                                {{item.organization_email}}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.organization_name}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'organizations.selected.text' | translate }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Teams -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.teams' | translate}}
                            </label>
                            <ng-select class="job-select-filter-field" [items]="teams | async" [multiple]="true"
                                formControlName="team" appendTo="body" bindLabel="team_name" bindValue="team_uid"
                                [loading]="teamFetching" [closeOnSelect]="false" [typeahead]="teamValueSubject"
                                (clear)="onTeamClear()" (search)="onTeamSearch()" (scrollToEnd)="onTeamScrollToEnd()"
                                placeholder="{{'text.select_teams' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        <div class="primary-font text-base flex items-center">
                                            <p>
                                                {{item.team_name}}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.team_name}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'text.teams_selected' | translate }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Users -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.users' | translate}}
                            </label>
                            <ng-select class="job-select-filter-field" [items]="employees | async" [multiple]="true"
                                formControlName="employee" appendTo="body" bindLabel="employee_name"
                                bindValue="user_uid" [loading]="employeeFetching" [closeOnSelect]="false"
                                [typeahead]="employeeValueSubject" (clear)="onEmployeeClear()"
                                (search)="onEmployeeSearch()" (scrollToEnd)="onEmployeeScrollToEnd()"
                                placeholder="{{'text.select_users' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        <div class="primary-font text-base flex items-center">
                                            <p>
                                                {{item.first_name}} {{item.last_name ?? ''}}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.first_name}} {{item.last_name ??
                                            ''}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'dispatch.filter.applicability_users.selected_text' |
                                            translate }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Property -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.property' | translate}}
                            </label>
                            <ng-select class="job-select-filter-field" [items]="properties | async" [multiple]="true"
                                formControlName="property" appendTo="body" bindLabel="property_name"
                                bindValue="property_uid" [loading]="propertyFetching" [closeOnSelect]="false"
                                [typeahead]="propertyValueSubject" (clear)="onPropertyClear()"
                                (search)="onPropertySearch()" (scrollToEnd)="onPropertyScrollToEnd()"
                                placeholder="{{'text.select_property' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        <div class="primary-font text-base flex flex-col">
                                            <p class="font-medium">
                                                {{item.property_name}}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.property_name}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'properties.selected.text' | translate}}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Priority -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.priority' | translate}}
                            </label>
                            <ng-select class="job-priority-filter" [items]="priorityTypes" bindLabel="priorityType"
                                bindValue="priorityKey" [clearable]="false" [searchable]="false" [hideSelected]="false"
                                appendTo="body" placeholder="{{'text.select_priority' | translate}}"
                                formControlName="priority">
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="primary-font text-base flex items-center">
                                        {{item.priorityType}}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Projects -->
                        <div class="mb-4" *ngIf="calendarService?.moduleAccess?.project">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.project' | translate}}
                            </label>
                            <ng-select class="job-select-filter-field" [items]="projects | async" [multiple]="true"
                                formControlName="project" appendTo="body" bindLabel="project_name"
                                bindValue="project_uid" [loading]="projectFetching" [closeOnSelect]="false"
                                [typeahead]="projectValueSubject" (clear)="onProjectClear()"
                                (search)="onProjectSearch()" (scrollToEnd)="onProjectScrollToEnd()"
                                placeholder="{{'text.select_project' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        <div class="primary-font text-base flex items-center">
                                            <p>
                                                {{item?.project_prefix ?? ''}} {{item.project_number ? (item.project_number + ' - '): ''}}{{item.project_name}}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.project_name}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'text.project.selected' |
                                            translate }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Job Skills -->
                        <div class="mb-4" *ngIf="skills">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.skills' | translate}}
                            </label>
                            <ng-select class="job-skills-filter" [items]="skills" bindLabel="skillset_name"
                                bindValue="skillset_uid" [multiple]="true" [searchable]="true" appendTo="body"
                                placeholder="{{'dispatch.filter.skills.placeholder' | translate}}"
                                formControlName="skills" [hideSelected]="false" [closeOnSelect]="false">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-2"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        {{item.skillset_name}}
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.skillset_name}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'skills.selected.text' | translate}}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <!-- Tags -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.tags' | translate}}
                            </label>
                            <ng-select class="job-select-filter-field" [items]="tags | async" [multiple]="true"
                                formControlName="tags" appendTo="body" bindLabel="tag_name" bindValue="tag_uid"
                                [loading]="tagFetching" [closeOnSelect]="false" [typeahead]="tagValueSubject"
                                (clear)="onTagClear()" (search)="onTagSearch()" (scrollToEnd)="onTagScrollToEnd()"
                                placeholder="{{'text.select_tags' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex items-center">
                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                            [checked]="item$.selected" (change)="$event.stopPropagation()" />
                                        <div class="primary-font text-base flex flex-col">
                                            <p class="font-medium">
                                                {{item.tag_name}}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="primary-font ng-value" *ngFor="let item of items | slice:0:2"
                                        [ngClass]="{'hidden' : items.length > 2}">
                                        <span class="ng-value-label text-base">{{item.tag_name}}</span>
                                        <span class="ng-value-icon right text-base" (click)="clear(item)"
                                            aria-hidden="true">×</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 2">
                                        <span class="primary-font ng-value-label text-base">
                                            {{items.length}} {{'text.selected_tags' | translate }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- Filter Footer -->
    <div class="dispatch-filter-footer-container border-t border-gray-100 w-full px-3 py-3.5 space-y-4"
        *ngIf="filterOptions?.footer?.enabled !== false">
        <div class="w-full px-4 flex justify-center" *ngIf="!hideSaveFilter">
            <div class="w-full flex items-center space-x-2">
                <input class="cursor-pointer" type="checkbox" [(ngModel)]="saveAsFilter" id="dispatch_save_filter" />
                <label for="dispatch_save_filter" class="cursor-pointer text-base">
                    {{'dispatch.filter.footer.save_as.filter' | translate}}</label>
            </div>
        </div>
        <div class="w-full px-4 flex justify-between gap-4">
            <button mat-stroked-button (click)="resetFilterPanel()"
                class="h-10 min-h-10 px-6 w-full items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                {{'reset.text' | translate}}
            </button>
            <button type="button" (click)="applyFilter()"
                class="bg-primary w-full px-4 h-10 items-center py-2 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none">
                {{'text.apply' | translate}}
            </button>
        </div>
    </div>
</div>
<div *ngIf="!isLoaded" class="flex justify-center items-center h-full">
    <lazy-loader></lazy-loader>
</div>